<template>
  <section :class="isWindowPopup ? 'container mt-5' : ''">
    <div class="row">
      <div class="col-md-12">
        <h5>{{ mode === 'create' ? 'สร้าง' : 'แก้ไข' }}ข้อมูลการประสานงาน

          <span v-if="mode === 'edit' && $route.query.id">รหัส #{{ $route.query.id }}</span>
        </h5>
      </div>
    </div>

    <form @submit.prevent="submitForm" class="text-left" v-if="coordinationCase">
      <div class="form-group" v-if="admin.shift_work_admin && admin.shift_work_admin.shift_work_type">
        <label for="" class="font-weight-bold">กะการทำงาน:</label> {{ admin.shift_work_admin.shift_work_type.name }}
      </div>

      <div class="form-group">
        <label for="coordination_type"><span style="color: red;">*</span> ประเภทการประสานงาน</label>
        <select name="coordination_type" required
                id="coordination_type" class="form-control" v-model="coordinationCase.coordination_case_type_id">
          <option value="">กรุณาเลือก</option>
          <template v-for="(item, index) in coordinationCaseTypes">
            <option :value="item.id" :key="index">{{ item.name }}</option>
          </template>
        </select>
      </div>

      <div class="form-group" v-if="coordinationCase.coordination_case_type_id === 6">
          <textarea class="form-control"
                    placeholder="โปรดระบุประเภทอื่นๆ..."
                    v-model="coordinationCase.coordination_case_type_other"></textarea>
      </div>

      <div class="form-group">
        <label for="detail_order"><span style="color: red;">*</span> รายละเอียดการจอง</label>
        <textarea class="form-control"
                  required
                  id="detail_order"
                  rows="10"
                  placeholder="โปรดระบุรายละเอียดการจอง"
                  v-model="coordinationCase.detail"></textarea>
      </div>

      <div class="form-group">
        <label for="order_remark">รหัสการจอง</label>
        <textarea class="form-control"
                  id="order_remark"
                  placeholder="ระบุรหัสการจอง"
                  v-model="coordinationCase.order_remark"></textarea>
      </div>

      <div class="form-group">
        <label for="tag_coordination">ติดแท็ก</label>

        <v-select id="tags"
                  placeholder="เลือกแท็ก"
                  name="tags"
                  label="name"
                  multiple
                  v-if="coordinationTags && coordinationTags.length > 0"
                  :options="coordinationTags"
                  v-model="selectedTags"
                  @input="onChangeTags"
        >
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              v-bind="attributes"
              v-on="events"/>
          </template>
          <template slot="no-options">
            ระบุแท็กที่เกี่ยวข้อง
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center" style="font-size: 11px;">
              {{ option.name }}
            </div>
          </template>
        </v-select>
      </div>
      <!--        <div class="form-group">
                <label for="pre_booking_remark">รหัส Pre Bookings</label>
                <textarea class="form-control"
                          id="pre_booking_remark"
                          placeholder="ระบุรหัส Pre Bookings"
                          v-model="coordinationCase.pre_booking_remark"></textarea>
              </div>-->

      <div class="form-group">
        <label for="remark">หมายเหตุอื่นๆ</label>
        <textarea class="form-control"
                  id="remark"
                  placeholder="ระบุหมายเหตุอื่นๆ"
                  v-model="coordinationCase.remark"></textarea>
      </div>

      <div class="form-group text-right">
        <button class="btn btn-primary" type="submit" :disabled="submitting">บันทึก</button>
      </div>
    </form>

    <modal-shift-work-admin ref="modalShiftWorkAdmin"></modal-shift-work-admin>
  </section>
</template>
<script>
import axios from 'axios'
import { mapActions, mapState } from 'vuex'
import ModalShiftWorkAdmin from '@/components/modal/ModalShiftWorkAdmin.vue'

export default {
  name: 'CoordinationForm',
  components: { ModalShiftWorkAdmin },
  props: ['selectedConversation'],
  data () {
    return {
      initialForm: {
        coordination_case_type_id: '',
        coordination_case_type_other: '',
        role: '',
        detail: '',
        remark: '',
        order_remark: ''
        // pre_booking_remark: ''
      },
      coordinationCase: null,
      selectedTags: [],
      hasOnChangeTags: false,
      mode: 'create',
      isWindowPopup: false,
      submitting: false
    }
  },
  computed: {
    ...mapState({
      admin: state => state.admin.admin,
      coordinationTags: state => state.tag.coordinationTags,
      coordinationCaseTypes: state => state.coordination.coordinationCaseTypes,
      adminBaseApiUrl: state => state.general.adminBaseApiUrl
    })
  },
  methods: {
    ...mapActions('coordination', [
      'fetchCoordination'
    ]),
    async getCoordinationCaseByID (coordinationCaseID) {
      try {
        const { data } = await axios.get('/coordination-case/' + coordinationCaseID)
        this.coordinationCase = data && data.coordination_case ? data.coordination_case : null

        this.initialData({ ...this.coordinationCase })
      } catch (err) {
        this.$swal({ text: err.message })
      }
    },
    onChangeTags (tags) {
      // ถ้าเป็นการส่งมาเป็น object ให้ convert เป็น array
      if (typeof tags === 'object' && !Array.isArray(tags) && tags !== null) {
        let createArray = []
        createArray.push(tags)
        tags = createArray
      }
      this.selectedTags = tags
    },
    initialData (coordinationCase = null) {
      this.selectedTags = []
      this.mode = !coordinationCase ? 'create' : 'edit'

      if (this.mode === 'edit' && coordinationCase.coordination_tag_xref && coordinationCase.coordination_tag_xref.length > 0) {
        // eslint-disable-next-line no-unused-vars
        for (let [_, item] of coordinationCase.coordination_tag_xref.entries()) {
          if (item.coordination_tag) {
            this.selectedTags.push({ ...item.coordination_tag })
          }
        }
      }

      if (coordinationCase) {
        this.coordinationCase = { ...coordinationCase }
      } else {
        this.coordinationCase = { ...this.initialForm }
      }
    },
    async submitForm () {
      try {
        this.submitting = true
        const params = { ...this.coordinationCase }
        params.conversation_id = this.selectedConversation ? this.selectedConversation.id : this.$route.query.conversation_id
        params.admin_id = this.admin.beneat_admin_id

        if (this.admin.shift_work_admin) {
          if (this.admin.shift_work_admin.shift_work_type_id) {
            params.shift_work_type_id = this.admin.shift_work_admin.shift_work_type_id
          }

          if (this.admin.shift_work_admin.role) {
            params.role = this.admin.shift_work_admin.role
          }
        } else {
          this.submitting = false
          this.$refs.modalShiftWorkAdmin.openModal()
          return
        }

        if (this.selectedTags && this.selectedTags.length > 0) {
          const selectedTagIDs = this.selectedTags.map(item => item.id)
          params.selected_tag_ids = selectedTagIDs
        }

        let url = '/coordination-case'
        let METHOD = 'post'
        if (this.mode === 'edit') {
          METHOD = 'put'
          url = '/coordination-case/' + this.coordinationCase.id
        }
        await axios[METHOD](url, params)
        this.submitting = false

        if (!this.isWindowPopup) {
          this.$emit('getCoordinationCase')
          this.$emit('closeModal')
        } else if (this.$route.query.conversation_id) {
          window.close()
        }

        this.$swal({
          text: 'สำเร็จ',
          type: 'success'
        })
      } catch (err) {
        this.submitting = false
        if (!this.isWindowPopup) {
          this.$emit('closeModal')
        }
        const message = err.response ? err.response.message : err.message
        this.$swal({
          text: 'ผิดพลาด ' + message,
          type: 'error'
        })
      }
    }
  },
  mounted () {
    if (this.$route.query.is_window_popup) {
      this.isWindowPopup = true
    }
  },
  created () {
    if (this.$route.query.id) {
      this.mode = 'edit'
      this.getCoordinationCaseByID(this.$route.query.id)
    } else {
      this.initialData()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
